module.exports = __webpack_public_path__ + "79ddbe05793c4aaea03621b7db932051.MP3";